import { ShellConfig } from 'ams-portal-shell';
import { setConfig } from './cache';
import { loadAppConfig } from '../appConfig';

const fetchConfig = async () => {
  const config = await loadAppConfig();
  const shellConfig = { publicUrl: config.publicUrl, auth: config.auth } as ShellConfig;
  setConfig(shellConfig);

  return shellConfig;
};

export default fetchConfig;
